import React from "react";
import { deleteContracts } from "../../apis/contract";
import { CONTRACT_TYPE } from "../../constants/CONTRACT";
import { contractDetail } from "../../utils/contract";
import { preventEvent } from "../../utils/element";
import systemAlert from "../../utils/systemAlert";
import Icon from "../Icon";
import ContractIcon from "../../assets/images/icon/contract/contract-doc-icon.svg";

const Contract = (props) => {
  const { type, isSigned, title
    //submit 
  } = props;
  const contract = CONTRACT_TYPE.find(contract => contract.type === type);

  const handleOnClick = () => {
    contractDetail(props);
  };
  const removeContract = (e) => {
    preventEvent(e);
    //console.log(props)
    systemAlert('계약서를 삭제 하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '승인',
          onClick: () => {
            deleteContracts(props.idx);
            window.location.reload();
          }
        }
      ]
    });
  };

  return (
    <div className="contarct-container" onClick={handleOnClick}>
      <div className="contract-img-wrap">
        <Icon src={contract ? contract.icon : ContractIcon} />
      </div>
      <div className="contract-name">
        {contract ? contract.label : title || '문서'}
        {!isSigned && (
          <span className="signed-text">
            서명대기
          </span>)}
        {!isSigned && (
          <span className="signed-remove" onClick={removeContract}>
            삭제하기
          </span>)}
      </div>
    </div>
  );
};

export default Contract;